// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/index.css
// module id = 2013
// module chunks = 0